import alfalfaSvg from 'assets/AllCropSVGs/alfalfa.svg';
import almondsSvg from 'assets/AllCropSVGs/almonds.svg';
import fallowSvg from 'assets/AllCropSVGs/fallow.svg';
import applesSvg from 'assets/AllCropSVGs/apples.svg';
import apricotsSvg from 'assets/AllCropSVGs/apricots.svg';
import artichokeGlobeSvg from 'assets/AllCropSVGs/artichokeGlobe.svg';
import asparagusSvg from 'assets/AllCropSVGs/asparagus.svg';
import bananaSvg from 'assets/AllCropSVGs/banana.svg';
import barleySvg from 'assets/AllCropSVGs/barley.svg';
import broadBeansSvg from 'assets/AllCropSVGs/broadBeans.svg';
import beetrootSvg from 'assets/AllCropSVGs/beetroot.svg';
import blackberriesSvg from 'assets/AllCropSVGs/blackberries.svg';
import berriesSvg from 'assets/AllCropSVGs/berries.svg';
import broccoliSvg from 'assets/AllCropSVGs/broccoli.svg';
import brusselSproutsSvg from 'assets/AllCropSVGs/brusselSprouts.svg';
import cabbageSvg from 'assets/AllCropSVGs/cabbage.svg';
import canolaSvg from 'assets/AllCropSVGs/canola.svg';
import carrotsSvg from 'assets/AllCropSVGs/carrots.svg';
import cauliflowerSvg from 'assets/AllCropSVGs/cauliflower.svg';
import celerySvg from 'assets/AllCropSVGs/celery.svg';
import cherriesSvg from 'assets/AllCropSVGs/cherries.svg';
import chickpeasSvg from 'assets/AllCropSVGs/chickpeas.svg';
import chivesSvg from 'assets/AllCropSVGs/chives.svg';
import cloverSvg from 'assets/AllCropSVGs/clover.svg';
import coffeeSvg from 'assets/AllCropSVGs/coffee.svg';
import corianderSvg from 'assets/AllCropSVGs/coriander.svg';
import cornSvg from 'assets/AllCropSVGs/corn.svg';
import cottonSvg from 'assets/AllCropSVGs/cotton.svg';
import cucumberSvg from 'assets/AllCropSVGs/cucumber.svg';
import dillLeafSvg from 'assets/AllCropSVGs/dillLeaf.svg';
import endiveSvg from 'assets/AllCropSVGs/endive.svg';
import forageCornSvg from 'assets/AllCropSVGs/forageCorn.svg';
import garlicSvg from 'assets/AllCropSVGs/garlic.svg';
import grapesSvg from 'assets/AllCropSVGs/grapes.svg';
import grassesSeedSvg from 'assets/AllCropSVGs/grassesSeed.svg';
import hazelnutsSvg from 'assets/AllCropSVGs/hazelnuts.svg';
import hempSvg from 'assets/AllCropSVGs/hemp.svg';
import hopsSvg from 'assets/AllCropSVGs/hops.svg';
import leeksSvg from 'assets/AllCropSVGs/leeks.svg';
import lettucesSvg from 'assets/AllCropSVGs/lettuces.svg';
import milletSvg from 'assets/AllCropSVGs/millet.svg';
import mushroomsSvg from 'assets/AllCropSVGs/mushrooms.svg';
import mustardRedSvg from 'assets/AllCropSVGs/mustardRed.svg';
import oatsSvg from 'assets/AllCropSVGs/oats.svg';
import oilseedRapeSvg from 'assets/AllCropSVGs/oilseedRape.svg';
import onionsSvg from 'assets/AllCropSVGs/onions.svg';
import parsnipsSvg from 'assets/AllCropSVGs/parsnips.svg';
import peanutsSvg from 'assets/AllCropSVGs/peanuts.svg';
import pearsSvg from 'assets/AllCropSVGs/pears.svg';
import peasSvg from 'assets/AllCropSVGs/peas.svg';
import pecansSvg from 'assets/AllCropSVGs/pecans.svg';
import peppersSvg from 'assets/AllCropSVGs/peppers.svg';
import pistachiosSvg from 'assets/AllCropSVGs/pistachios.svg';
import plumsSvg from 'assets/AllCropSVGs/plums.svg';
import pomeFruitsSvg from 'assets/AllCropSVGs/pomeFruits.svg';
import potatoSvg from 'assets/AllCropSVGs/potato.svg';
import pumpkinsSvg from 'assets/AllCropSVGs/pumpkins.svg';
import radicchioSvg from 'assets/AllCropSVGs/radicchio.svg';
import raspberriesSvg from 'assets/AllCropSVGs/raspberries.svg';
import rhubarbSvg from 'assets/AllCropSVGs/rhubarb.svg';
import riceSvg from 'assets/AllCropSVGs/rice.svg';
import ryeSvg from 'assets/AllCropSVGs/rye.svg';
import soybeansSvg from 'assets/AllCropSVGs/soybeans.svg';
import spinachSvg from 'assets/AllCropSVGs/spinach.svg';
import squashSvg from 'assets/AllCropSVGs/squash.svg';
import strawberriesSvg from 'assets/AllCropSVGs/strawberries.svg';
import sugarBeetSvg from 'assets/AllCropSVGs/sugarBeet.svg';
import sugarcaneSvg from 'assets/AllCropSVGs/sugarcane.svg';
import sunflowerSvg from 'assets/AllCropSVGs/sunflower.svg';
import sweetPotatoSvg from 'assets/AllCropSVGs/sweetPotato.svg';
import tobaccoSvg from 'assets/AllCropSVGs/tobacco.svg';
import tomatoesSvg from 'assets/AllCropSVGs/tomatoes.svg';
import treeNutsSvg from 'assets/AllCropSVGs/treeNuts.svg';
import triticaleSvg from 'assets/AllCropSVGs/triticale.svg';
import turnipsSvg from 'assets/AllCropSVGs/turnips.svg';
import vetchSvg from 'assets/AllCropSVGs/vetch.svg';
import walnutsSvg from 'assets/AllCropSVGs/walnuts.svg';
import watermelonSvg from 'assets/AllCropSVGs/watermelon.svg';
import wheatSvg from 'assets/AllCropSVGs/wheat.svg';

export default {
  Alfalfa: alfalfaSvg,
  Almond: almondsSvg,
  Amaranth: fallowSvg,
  AnnualRyegrass: fallowSvg,
  Apple: applesSvg,
  Apricot: apricotsSvg,
  Aquatic: fallowSvg,
  Artichoke: artichokeGlobeSvg,
  Arugula: fallowSvg,
  Asparagus: asparagusSvg,
  Avocado: fallowSvg,
  BahiaGrass: fallowSvg,
  Banana: bananaSvg,
  Barley: barleySvg,
  Basil: fallowSvg,
  Bean: broadBeansSvg,
  Beets: beetrootSvg,
  Bentgrass: fallowSvg,
  Bermudagrass: fallowSvg,
  Bittermelon: fallowSvg,
  Blackberry: blackberriesSvg,
  BluePanicGrass: fallowSvg,
  Blueberry: berriesSvg,
  Bluegrass: fallowSvg,
  Bluestem: fallowSvg,
  BristleGrass: fallowSvg,
  Broccoli: broccoliSvg,
  BroccoliRaab: broccoliSvg,
  BrusselsSprout: brusselSproutsSvg,
  Buckwheat: fallowSvg,
  Buffelgrass: fallowSvg,
  BundleflowerGrass: fallowSvg,
  Cabbage: cabbageSvg,
  CactusPear: fallowSvg,
  Canola: canolaSvg,
  Cantaloupe: fallowSvg,
  Carambola: fallowSvg,
  Carrots: carrotsSvg,
  Cauliflower: cauliflowerSvg,
  Celery: celerySvg,
  Cherry: cherriesSvg,
  Chervil: fallowSvg,
  Chestnut: fallowSvg,
  ChewingFescue: fallowSvg,
  Chickpea: chickpeasSvg,
  Chicory: fallowSvg,
  Chives: chivesSvg,
  Chrysanthemum: fallowSvg,
  Cilantro: fallowSvg,
  Clover: cloverSvg,
  Coffee: coffeeSvg,
  CollardGreens: fallowSvg,
  Coriander: corianderSvg,
  Corn: cornSvg,
  Cotton: cottonSvg,
  CoverCrop: fallowSvg,
  Crabgrass: fallowSvg,
  Cranberry: berriesSvg,
  Crawfish: fallowSvg,
  Crenshaw: fallowSvg,
  CREP: fallowSvg,
  CRP: fallowSvg,
  CSP: fallowSvg,
  Cucumber: cucumberSvg,
  Currants: fallowSvg,
  Daffodil: fallowSvg,
  Daikon: fallowSvg,
  Dandelion: fallowSvg,
  Dill: dillLeafSvg,
  Echinacea: fallowSvg,
  Edamame: fallowSvg,
  Eggplant: fallowSvg,
  Endive: endiveSvg,
  Escarole: fallowSvg,
  Fallow: fallowSvg,
  Fennel: fallowSvg,
  Fenugreek: fallowSvg,
  Festulolium: fallowSvg,
  Filbert: fallowSvg,
  FineFescue: fallowSvg,
  Flax: fallowSvg,
  Flowers: fallowSvg,
  ForageSorghum: forageCornSvg,
  Garlic: garlicSvg,
  Ginseng: fallowSvg,
  Gourd: fallowSvg,
  GrainSorghum: fallowSvg,
  Grapefruit: grapesSvg,
  Grapes: grapesSvg,
  GrassSeedMixed: grassesSeedSvg,
  GreenManure: fallowSvg,
  Guava: fallowSvg,
  Guayule: fallowSvg,
  HardSquash: fallowSvg,
  Hay: fallowSvg,
  Hazelnut: hazelnutsSvg,
  Hemp: hempSvg,
  Honeydew: fallowSvg,
  Hops: hopsSvg,
  Horseradish: fallowSvg,
  Kale: fallowSvg,
  Kenaf: fallowSvg,
  Kiwi: fallowSvg,
  KleinGrass: fallowSvg,
  Kohlrabi: fallowSvg,
  Lavender: fallowSvg,
  Leasedland: fallowSvg,
  Leek: leeksSvg,
  Lemon: fallowSvg,
  Lemongrass: fallowSvg,
  Lentil: fallowSvg,
  Lespedeza: fallowSvg,
  Lettuce: lettucesSvg,
  LillyBulb: fallowSvg,
  LimaBean: fallowSvg,
  Lime: fallowSvg,
  Lovegrass: fallowSvg,
  Lychee: fallowSvg,
  MacadamiaNut: fallowSvg,
  Mandarin: fallowSvg,
  Mango: fallowSvg,
  Marjoram: fallowSvg,
  MeadowFescue: fallowSvg,
  MeadowFoam: fallowSvg,
  MedicGrass: fallowSvg,
  Metaleaf: fallowSvg,
  Millet: milletSvg,
  Mint: fallowSvg,
  Miscanthus: fallowSvg,
  Mizuna: fallowSvg,
  Moqua: fallowSvg,
  Mushrooms: mushroomsSvg,
  Mustard: mustardRedSvg,
  MustardGreens: mustardRedSvg,
  MWD: fallowSvg,
  Nectarine: fallowSvg,
  NonAg: fallowSvg,
  NonCrop: fallowSvg,
  NurseryStock: fallowSvg,
  Oats: oatsSvg,
  OilPalm: oilseedRapeSvg,
  Okra: fallowSvg,
  Olive: fallowSvg,
  Onions: onionsSvg,
  Opo: fallowSvg,
  Orange: fallowSvg,
  Orchardgrass: fallowSvg,
  Oregano: fallowSvg,
  Papaya: fallowSvg,
  Parsley: fallowSvg,
  Parsnip: parsnipsSvg,
  PassionFruit: fallowSvg,
  Pasture: fallowSvg,
  Peach: fallowSvg,
  Peanut: peanutsSvg,
  Pear: pearsSvg,
  Peas: peasSvg,
  Pecan: pecansSvg,
  Pepper: peppersSvg,
  PerennialRyegrass: fallowSvg,
  Persimmon: fallowSvg,
  Pistachio: pistachiosSvg,
  Plantain: fallowSvg,
  Plum: plumsSvg,
  Pluot: fallowSvg,
  Pomegranate: pomeFruitsSvg,
  Pomelo: fallowSvg,
  Pond: fallowSvg,
  Pongamia: fallowSvg,
  PostHarvest: fallowSvg,
  Potato: potatoSvg,
  PreventedPlanting: fallowSvg,
  Pumpkin: pumpkinsSvg,
  Quinoa: fallowSvg,
  Radish: radicchioSvg,
  Rape: fallowSvg,
  Raspberry: raspberriesSvg,
  Rhubarb: rhubarbSvg,
  Rice: riceSvg,
  Rosemary: fallowSvg,
  Rutabaga: fallowSvg,
  Rye: ryeSvg,
  Safflower: fallowSvg,
  Sage: fallowSvg,
  Sainfoin: fallowSvg,
  Savory: fallowSvg,
  SeedProduction: fallowSvg,
  Sesame: fallowSvg,
  SetAside: fallowSvg,
  Sinqua: fallowSvg,
  Sod: fallowSvg,
  Sorrel: fallowSvg,
  Soybeans: soybeansSvg,
  Spelt: fallowSvg,
  Spinach: spinachSvg,
  SpriteMelon: fallowSvg,
  Squash: squashSvg,
  Stevia: fallowSvg,
  Strawberry: strawberriesSvg,
  SudanGrass: fallowSvg,
  SugarBeets: sugarBeetSvg,
  Sugarcane: sugarcaneSvg,
  Sunflower: sunflowerSvg,
  SunnHemp: hempSvg,
  SweetCorn: cornSvg,
  SweetPotato: sweetPotatoSvg,
  SweetSorghum: fallowSvg,
  SwissChard: fallowSvg,
  Switchgrass: fallowSvg,
  TallFescue: fallowSvg,
  Tangelo: fallowSvg,
  Tangerine: fallowSvg,
  Tarragon: fallowSvg,
  Teff: fallowSvg,
  Thyme: fallowSvg,
  Timothy: fallowSvg,
  Tobacco: tobaccoSvg,
  Tomatillos: fallowSvg,
  Tomato: tomatoesSvg,
  Trees: treeNutsSvg,
  Triticale: triticaleSvg,
  Tulips: fallowSvg,
  TurnRow: fallowSvg,
  TurnipGreens: turnipsSvg,
  Turnips: turnipsSvg,
  Undecided: fallowSvg,
  Vetch: vetchSvg,
  Walnut: walnutsSvg,
  Watercress: fallowSvg,
  Watermelon: watermelonSvg,
  Wheat: wheatSvg,
  WildlifeRefuge: fallowSvg,
  WindmillGrass: fallowSvg,
  WRP: fallowSvg
};
